import { useTheme } from '@shopify/restyle';
import { images } from 'app/design/images';
import { Column, Row } from 'app/design/primitives/box';
import { Text } from 'app/design/primitives/text';
import { useScopedTranslation } from 'app/hooks/i18n';
import { Pressable } from 'react-native';
import { PCImage } from 'app/design/primitives/image';
import type { Theme } from 'app/shopify';

export function InviteCodeCard({ inviteCode, onCopy }: { inviteCode?: string; onCopy: () => void }) {
  const { t } = useScopedTranslation();
  const theme = useTheme<Theme>();
  return (
    <Pressable onPress={onCopy} style={{ width: '100%' }}>
      <Column
        alignItems="center"
        gap="spacing.general.x4"
        style={{
          borderColor: theme.colors['surface.tertiary'],
          borderRadius: theme.borderRadii['radius.xl'],
          borderWidth: 1,
          padding: theme.spacing['spacing.general.x4'],
        }}
      >
        <Text fontWeight="700" textAlign="center" variant="headerXSmall">
          {t('subtitle')}
        </Text>
        <Column
          alignItems="center"
          gap="spacing.general.x2"
          style={{
            backgroundColor: theme.colors['surface.tertiary-neutral'],
            borderRadius: theme.borderRadii['radius.lg'],
            width: '100%',
            paddingVertical: theme.spacing['spacing.general.x8'],
            paddingHorizontal: theme.spacing['spacing.general.x4'],
          }}
        >
          <Row alignItems="center">
            <Text fontSize={30} fontWeight="bold" textAlign="center" variant="bodyBase">
              {inviteCode}
            </Text>
            <PCImage height={31} source={images.copy} width={31} />
          </Row>
        </Column>
      </Column>
    </Pressable>
  );
}
